module.exports = __webpack_public_path__ + "static/profile-4-dfedcd5fa47bd2742c7a87f74b6eec29.jpg";